import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetPendingOrdersStatsQuery = ({
  timePeriod,
  customStartDate,
  customEndDate,
}: {
  timePeriod?: string;
  customStartDate?: string;
  customEndDate?: string;
}) => {
  const token = getToken();

  const params: any = {};
  if (timePeriod) params.timePeriod = timePeriod;
  if (customStartDate) params.customStartDate = customStartDate;
  if (customEndDate) params.customEndDate = customEndDate;

  return useQuery({
    queryKey: ["useGetPendingOrdersStatsQuery", params],
    queryFn: () =>
      axiosInstance
        .get("dashboard/pending-orders", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
